<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row mt-0">
      <div class="col-sm-12 custom-form-main-label" v-if="bookingResourceId == 0">
        {{$t('add_resource')}}
      </div>
    </div>
    <div class="row mt-0" v-if="bookingResourceId != 0">
      <div class="col-sm-12 custom-form-main-label">
        {{$t('manage_resource')}}
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form id="createResourceForm" name="createResourceForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('resource_name')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input required v-model="resourcename" type="text" id="txtresourcename" v-bind:placeholder="$t('resource_name')" maxlength="200" name="resourcename" class="form-control" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('resource_type')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <select required class="form-control" v-bind:id="'select_assigned_resourcetype_' +  getId()">
                <option value="" style="">{{ $store.translate('select_resourcetype')}}</option>
                <option v-for="type in resourceTypes" v-bind:value="type.Id">
                  {{ type.Name }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12">
              <button @click="createResource" type="submit" class="btn skin primary-button pull-right"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  let message = "";
  var resourceTypes = [];
  export default {
    name: "add-resource",
    components: {

    },
    props: {
      bookingResourceId: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        resourceTypes: [],
        message: "",
        resourcename: "",
      };
    },
    methods: {
      getId() {
        return this._uid;
      },
      async getBookingResourceTypes() {
        try {
          var url = "/api/Bookings/v1/Types?";
          this.$http.get(url).then(async response => {
            this.resourceTypes = response.data;
            $('#select_assigned_resourcetype_' + this.getId()).select2();
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      },
      clearFields() {
        this.resourcename = '';
        $("#select_assigned_resourcetype_" + this.getId()).val('');
        $("#select_assigned_resourcetype_" + this.getId()).trigger('change');
      },
      async createResource() {
        if (!$('#createResourceForm').valid())
          return false;
        var request = { Id: this.bookingResourceId, Name: this.resourcename, ResourceType: $('#select_assigned_resourcetype_' + this.getId()).val() };

        try {
          var response = await this.$http.post(
            '/api/Bookings/v1/Resources',
            request
          ).then(async response => {
            this.clearFields();
            vm.$root.$emit('refreshview');
          });

        } catch (err) {
          alert(err);
        }
      },
      async getBookingResource(bookingResourceId) {
        try {
          this.$http.get(`/api/Bookings/v1/Resources/${bookingResourceId}`).then(async response => {
            var resource = response.data;
            this.resourcename = resource.Name;

            if (resource.ResourceType !== '' && resource.ResourceType !== null) {
              $("#select_assigned_resourcetype_" + this.getId()).val(resource.ResourceType);
              $("#select_assigned_resourcetype_" + this.getId()).trigger('change');
            } else {
              $("#select_assigned_resourcetype_" + this.getId()).val('');
              $("#select_assigned_resourcetype_" + this.getId()).trigger('change');
            }
          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      bookingResourceId: function (newVal, oldVal) {
        if (newVal > 0) {
          this.getBookingResource(newVal);
        } else {
          this.resourcename = '';
          this.description = '';
        }
      }
    },
    mounted() {
      _componentValidation('#createResourceForm');
      if (this.bookingResourceId > 0) {
        this.getBookingResource(this.bookingResourceId);
      }
      this.getBookingResourceTypes();
    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/booking/add-resource.vue